import { Box } from "@mui/material";
import useSignUrl from "./useSignUrl";
const CenterCard = ({ cover_img,sx ,style}) => {
  const signedUrl = useSignUrl(cover_img);
  const defaultSrc = signedUrl || null;
  return (
      <Box sx={{...sx}}>
        <img
          src={defaultSrc}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "contain",...style }}
        />
      </Box>
  );
};
export default CenterCard;
